export const AUTO = 1;
export const RCVAT = 2;
export const VIDA = 3;
export const MICRO_VIDA = 4;

export const PRODUCT_NAME = {
  AUTO: 'AUTOMÓVEL',
  RCVAT: 'RCVAT',
  VIDA: 'VIDA',
  MICRO_VIDA: 'MICROVIDA',
};

export const PRODUCT_TAG = {
  [AUTO]: 'AUTO ANUAL',
  [RCVAT]: 'RCVAT',
  [VIDA]: 'VIDA',
  [MICRO_VIDA]: 'MICROVIDA',
};

export const POLICY_CREATION_TYPE = {
  ENDORSEMENT: { label: 'Endosso', value: 'ENDORSEMENT' },
  NEW_POLICY: { label: 'Nova Apólice', value: 'NEW_POLICY' },
};
